import type { WeatherOption } from '../types';

export const WEATHER_IDS = {
  CLEAR: 'clear',
  OVERCAST: 'overcast',
  RAIN: 'rain',
  SNOW: 'snow',
} as const;

export const DEFAULT_WEATHER_ID = WEATHER_IDS.CLEAR;

/**
 * 배경 위치와 별도로 적용되는 날씨입니다. 같은 서킷에서도 날씨만 바꾸면 조명, 시야,
 * 노면 반사, 강수와 타이어 그립이 함께 바뀝니다.
 */
export const weatherOptions: readonly WeatherOption[] = [
  {
    id: WEATHER_IDS.CLEAR,
    name: '맑음',
    description: '선명한 시야 · 마른 노면',
    icon: '☀',
    precipitation: 'none',
    precipitationIntensity: 0,
    ambientLightMultiplier: 1,
    directLightMultiplier: 1,
    environmentIntensityMultiplier: 1,
    backgroundIntensityMultiplier: 1,
    roadWetness: 0,
    roadTint: '#ffffff',
    gripMultiplier: 1,
    rollingResistanceMultiplier: 1,
  },
  {
    id: WEATHER_IDS.OVERCAST,
    name: '흐림',
    description: '부드러운 광원 · 옅은 안개',
    icon: '☁',
    precipitation: 'none',
    precipitationIntensity: 0,
    fog: { color: '#aab2b9', near: 180, far: 940 },
    ambientLightMultiplier: 0.92,
    directLightMultiplier: 0.66,
    environmentIntensityMultiplier: 0.84,
    backgroundIntensityMultiplier: 0.82,
    roadWetness: 0.08,
    roadTint: '#e7eaec',
    gripMultiplier: 0.97,
    rollingResistanceMultiplier: 1.02,
  },
  {
    id: WEATHER_IDS.RAIN,
    name: '비',
    description: '강한 빗줄기 · 젖은 저그립 노면',
    icon: '☂',
    precipitation: 'rain',
    precipitationIntensity: 0.86,
    fog: { color: '#75818b', near: 90, far: 620 },
    ambientLightMultiplier: 0.76,
    directLightMultiplier: 0.46,
    environmentIntensityMultiplier: 0.72,
    backgroundIntensityMultiplier: 0.68,
    roadWetness: 1,
    roadTint: '#929ba3',
    gripMultiplier: 0.67,
    rollingResistanceMultiplier: 1.1,
  },
  {
    id: WEATHER_IDS.SNOW,
    name: '눈',
    description: '폭설 · 미끄러운 설면',
    icon: '❄',
    precipitation: 'snow',
    precipitationIntensity: 0.78,
    fog: { color: '#d9e0e5', near: 65, far: 430 },
    ambientLightMultiplier: 0.9,
    directLightMultiplier: 0.56,
    environmentIntensityMultiplier: 0.8,
    backgroundIntensityMultiplier: 0.76,
    roadWetness: 0.58,
    roadTint: '#c7cdd1',
    gripMultiplier: 0.48,
    rollingResistanceMultiplier: 1.28,
  },
];

export function findWeatherById(weatherId: string): WeatherOption | undefined {
  return weatherOptions.find((weather) => weather.id === weatherId);
}
